import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link} from 'react-router-dom';
import auth from '../auth';

import LogoImage from 'url:../images/logo@2x.png';
import { useToast } from '../toast';
import config from '../config';

export default function TopBar () {
  return (
    <div css={css`height: 105px`}>
      <TopbarMain/>
    </div>
  );
};

const TopbarMain = () => {
  const history = useHistory();
  const [viewMenu, setViewMenu] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (viewMenu) {
      const onClickOutside = () => setViewMenu(false);

      document.addEventListener('click', onClickOutside);
      return () => document.removeEventListener('click', onClickOutside);
    }
  }, [viewMenu]);

  const toggleMenu = () => {
    if (viewMenu) {
      setViewMenu(false);
    } else {
      setViewMenu(true);
    }
  };

  const doLogout = () => {
    auth.logout();
    setViewMenu(false);
    history.push('/login');
    toast.info('ログアウトしました');
  };

  return (
    <div css={css`
      position: fixed;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      padding: 0 1rem;
      background: #fff;
      border-bottom: 1px solid #CCCCCC;
      z-index: 10;
      width: 100%;
    `}>
      <Link to="/"><img src={LogoImage} css={css`height: 32px;`} /></Link>
      <div css={css`position: relative;`}>
        <span className="material-icons-outlined" css={css`font-size: 30px; cursor: pointer;`} onClick={toggleMenu}>settings</span>
        <div css={css`
          display: ${viewMenu ? `inline-flex` : `none`};
          position: absolute;
          top: 100%;
          right: 0;

          background-color: white;
          top: calc(100% + 1px);
          right: 0;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
          z-index: 1;
          flex-direction: column;
          font-size: 16px;
          white-space: nowrap;

          a {
            display: flex;
            align-items: center;
            padding: 0.5rem 1rem;
            background: #fff;
            color: black;
            &:hover {
              background: #EEE;
            }

            span {
              margin-right: 10px;
            }
          }
        `}>
          <div>
            <a href={`${config.storage}/manual.pdf`} target="_blank"><span className="material-icons">menu_book</span>操作マニュアル</a>
            <a href="https://docs.google.com/forms/d/1bvHv90OT7Uhzn1aYwi_wWEbHxr42-AwFOTrcUN3XphE/edit" target="_blank"><span className="material-icons">feed</span>質問フォーム</a>
            <a css={css`cursor: pointer;`} onClick={() => doLogout()}><span className="material-icons">logout</span>ログアウト</a>
          </div>
          <div css={css`padding: 0.5rem 0; text-align: right; border-top: 1px solid #EEE`}>
            <span css={css`color: #CCC; margin-right: 1rem; font-size: 12px`}>v{config.version}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
